<template>
	<v-app id="app">
		<v-content>
			<router-view />
		</v-content>
	</v-app>
</template>

<script>
export default {
	name: 'App',
	data: () => ({
		//
	}),
}
</script>

<style lang="scss">
@media print {
	.no-print {
		display: none !important;
	}
	.v-content {
		padding: 0 !important;
	}
}
</style>
